













import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      imgUrl: require('assets/img/crown.svg'),
      upgradeReason: '权限不足',
      reasonDesc: '当前模块需要升级购买',
    };
  },
  methods: {
    toUpgrade() {
      window.location.href = '#/upgrade/buy';
    },
  },
});
